// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-c3a57c2e]{z-index:1;position:absolute;top:0;left:0;pointer-events:none}", ""]);
// Exports
module.exports = exports;
